import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';

import { bem } from 'helpers/class-name';
import Tabs, { Tab, TabLabel } from 'components/Tabs';
import { Card, CardTitle } from 'components/Card';
import Message from 'components/Message';
import { intlMessage } from 'constants/propTypes';
import PeakTimeDefinition from './PeakTimeDefinition';

import './SmartToolsSection.scss';

const { block, element } = bem('smart-tools-section');

const SmartToolsSection = ({
  title,
  description,
  settingDetail,
  icon,
  children,
  className,
  countryCode,
  learnMoreLink,
  handleLearnMore,
  learnMoreLocation,
  tabs,
  selectedTab,
  onTabChange,
  tabsClassName,
}) => {
  return (
    <Card className={block(className)}>
      <div className={element('header')}>
        {icon && <Isvg className={element('icon')} src={icon} />}
        <div className={element('header-content')}>
          <Message as={CardTitle} message={title} />
          {description && (
            <Message
              as="p"
              className={element('description')}
              message={description}
              values={{
                a: text => (
                  <a href={learnMoreLink} target="_blank" rel="noopener noreferrer">
                    {text}
                  </a>
                ),
              }}
              onClick={() => handleLearnMore(learnMoreLocation)}
            />
          )}
        </div>
      </div>
      {settingDetail && (
        <div className={element('setting-info')}>
          <Message as="p" message={settingDetail} />
        </div>
      )}
      {tabs && selectedTab && onTabChange && (
        <div className={element('tabs', tabsClassName)}>
          <Tabs selectedTab={selectedTab} onTabChange={onTabChange} tabListProps={{ className: element('tabs-list') }}>
            {tabs.map(tab => (
              <Tab key={tab.name} name={tab.name}>
                <TabLabel>
                  <Message message={tab.label} />
                </TabLabel>
              </Tab>
            ))}
          </Tabs>
        </div>
      )}
      <div className={element('content')}>{children}</div>
      {countryCode && <PeakTimeDefinition countryCode={countryCode} />}
    </Card>
  );
};

SmartToolsSection.propTypes = {
  title: intlMessage.isRequired,
  description: intlMessage,
  settingDetail: intlMessage,
  icon: PropTypes.string,
  children: PropTypes.node.isRequired,
  countryCode: PropTypes.string,
  className: PropTypes.string,
  learnMoreLink: PropTypes.string,
  handleLearnMore: PropTypes.func,
  learnMoreLocation: PropTypes.string,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: intlMessage.isRequired,
    })
  ),
  selectedTab: PropTypes.string,
  onTabChange: PropTypes.func,
  tabsClassName: PropTypes.string,
};

export default SmartToolsSection;
